import { useQuery } from "@tanstack/react-query";
import { useApi } from "@utils/useApi";
import {
  CompanyStandardsClient,
  type GetStandardsFoldersResponse,
} from "@lib/ShiOneClient";
import { GetCompanyStandardsHookFn } from "shared-ui/src/types/ecommerce/UseStandardsTypes";

export const EcommerceQueryKeys = {
  CompanyStandards: "ecommerce-company-standards",
} as const;

/**
 * Customer Experience equivalent of Customer Success `useGetCompanyStandards`.
 *
 * CX must call WebApi (API boundary rule): GET /api/ecommerce/company-standards/{orgUnitId}
 */
const useGetCompanyStandards: GetCompanyStandardsHookFn = (
  orgUnitId: string | null | undefined,
) => {
  const companyStandardsApi = useApi(CompanyStandardsClient);

  const fetchCompanyStandards = async (): Promise<
    GetStandardsFoldersResponse | undefined
  > => {
    if (!orgUnitId) return;

    const numericId = Number(orgUnitId);
    if (isNaN(numericId)) return;

    return await companyStandardsApi.get(numericId);
  };

  const isValidOrgUnitId = !!orgUnitId && !isNaN(Number(orgUnitId));

  return useQuery({
    queryKey: [EcommerceQueryKeys.CompanyStandards, orgUnitId],
    queryFn: fetchCompanyStandards,
    enabled: isValidOrgUnitId,
  });
};

export default useGetCompanyStandards;
